import { createSlice } from "@reduxjs/toolkit";

const parkingSlice = createSlice({
  name: "parking",
  initialState: false,
  reducers: {
    success(state, action) {
      state = action.payload;
      return state;
    },
  },
});

export const { success } = parkingSlice.actions;
export default parkingSlice.reducer;
